
import axios from "axios";
import { store } from "store";
import { OutputBaseProps } from "utils/types/API";
import { PostItemProps } from ".";
import { loading, endLoading } from "store/post";

interface ApiPostRemoveInputProps {
    ids: number[]
}

type ApiPostRemoveOutputProps = OutputBaseProps<{ item: PostItemProps; }>;

export const apiPostRemove = async (data: ApiPostRemoveInputProps) => {
    store.dispatch(loading());
    const res = (await axios.delete<ApiPostRemoveOutputProps>("/api/post/remove", { data }))
        .data;
    store.dispatch(endLoading());
    return res;
};